'use strict';

var GridExportButtonController = function GridExportButtonController($scope, fileSaveService, columnNameTransformationService) {
  var gridPanel = $scope.gridPanelScope;
  function exportData(gridSettings) {
    var columnsToHide = columnNameTransformationService.getColumnsToHide(gridSettings);
    columnNameTransformationService.hideColumns(gridSettings, columnsToHide);
    var data = gridSettings.apply('exportdata', 'xls');
    columnNameTransformationService.unhideColumns(gridSettings, columnsToHide);
    return data;
  }
  $scope.exportToExcel = function () {
    var fileType = 'application/vnd.ms-excel;charset=UTF-8';

    //parse print xml to suffix excluded columngroup names onto column names
    var data = exportData(gridPanel.jqxGridSettings);
    data = columnNameTransformationService.flattenColumnNames(data, gridPanel.jqxGridSettings, 'xls');
    if ($scope.postExportDataTransformer) {
      data = $scope.postExportDataTransformer(data);
    }

    // Notice: if we use .xls extension here, Excel will complain about compatibility problems.
    // On the other hand, the .xml extension might be too generic.
    var fileExtension = 'xml';
    var fileName = fileSaveService.createFileName(gridPanel.gridId, fileExtension);
    fileSaveService.createFile(data, fileType, fileName);
  };
};
GridExportButtonController.$inject = ['$scope', 'FileSaveService', 'ColumnNameTransformationService'];
module.exports = GridExportButtonController;